export enum TICKET_FILTERS {
  SEARCH = 'SEARCH',
  SERVICE_HASH_IDS = 'SERVICE_HASH_IDS',
  IS_CANCELLED = 'IS_CANCELLED',
  ACTIVATED_AT_RANGE = 'ACTIVATED_AT_DATE_RANGE',
  VALID_RANGE = 'VALID_DATE_RANGE',
  VALIDATED_AT_RANGE = 'VALIDATED_AT_DATE_RANGE',
}
